<template>
  <div
    class="question jblock is-vertical-center"
    :class="{ 'is-money': null === state }"
    @click="swapState"
  >
    <h4 v-if="state === 'answer'">
      {{ question.answer }}
    </h4>
    <h4 v-else-if="state === 'clue'">
      {{ question.clue }}
    </h4>
    <h4 v-else>
      ${{ question.value }}
    </h4>
  </div>
</template>

<script>
  import EventBus from '@/EventBus';

  export default {
    name: 'Question',
    props: {
      question: Object,
      highlighted: Boolean,
    },

    data() {
      return {
        state: null, // maybe move this into the Question object so it can be shared between Q and ActiveQuestion
        answered: false,
      };
    },

    created() {
      window.addEventListener('keyup', this.processKeys);
    },

    methods: {
      swapState() {
        // track when Qs are revealed for tracking coryat
        if (!this.state) EventBus.$emit('revealed', this.question);

        this.state = this.state === 'clue' ? 'answer' : 'clue';
      },

      processKeys(evt) {
        if (
          this.highlighted &&
          evt.key === 'Enter'
        ) {
          this.swapState();
        }
      },
    },

    watch: {
      'question.state': function(val) {
        // watching this so when the ActiveQuestion updates it we can update the board state
        this.state = val;
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  $blue: rgb(6, 12, 234);

  .question {
    cursor: pointer;

    h4 {
      font-size: 1.1rem;
      font-family: 'Markazi Text', serif;
      text-shadow: 2px 2px 2px #000000;
    }

    &.is-money {
      h4 {
        font-size: 2rem;
        font-weight: 800;
        color: yellow;
        font-family: Helvetica, sans-serif;
      }
    }
  }

</style>
